module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Marti_Natalia.63d0f2d8.jpg";